import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../assets/imgs/logo.svg';
const _hoisted_1 = [
    "data-fixed",
    "data-sticky",
    "data-show-env-hint"
];
const _hoisted_2 = {
    key: 0,
    class: "pe-main-header_wrapper",
    "data-version": "v2"
};
const _hoisted_3 = {
    key: 0,
    class: "pe-main-header_row"
};
const _hoisted_4 = {
    class: "pe-main-header_side"
};
const _hoisted_5 = {
    class: "pe-main-header_back"
};
const _hoisted_6 = {
    class: "pe-main-header_row pe-main-header_row-pc"
};
const _hoisted_7 = {
    class: "pe-main-header_side"
};
const _hoisted_8 = {
    class: "pe-main-header_center"
};
const _hoisted_9 = {
    class: "pe-main-header_title"
};
const _hoisted_10 = {
    class: "pe-main-header_side"
};
const _hoisted_11 = {
    style: {
        "margin-right": "12px"
    }
};
const _hoisted_12 = {
    class: "pe-main-header_user"
};
const _hoisted_13 = {
    key: 0,
    class: "pe-main-header_user-avatar"
};
const _hoisted_14 = [
    "src"
];
const _hoisted_15 = {
    class: "pe-main-header_user-name"
};
const _hoisted_16 = {
    key: 1,
    class: "pe-main-header_wrapper"
};
const _hoisted_17 = {
    class: "pe-main-header_row"
};
const _hoisted_18 = {
    class: "pe-main-header_side"
};
const _hoisted_19 = {
    class: "pe-main-header_back"
};
const _hoisted_20 = {
    class: "pe-main-header_center"
};
const _hoisted_21 = {
    class: "pe-main-header_select-options"
};
const _hoisted_22 = {
    key: 1,
    class: "pe-main-header_title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _ctx_employeeInfo_avatar, _ctx_employeeInfo, _ctx_userInfo, _ctx_titleSelected;
    const _component_EnvTag = _resolveComponent("EnvTag");
    const _component_BizArea = _resolveComponent("BizArea");
    const _component_CellSelect = _resolveComponent("CellSelect");
    const _component_van_popup = _resolveComponent("van-popup");
    return _openBlock(), _createElementBlock("div", {
        id: "peMainHeader",
        class: "pe-main-header",
        "data-fixed": _ctx.fixed,
        "data-sticky": _ctx.sticky,
        "data-show-env-hint": _ctx.showEnvHint
    }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "pe-main-header_status-bar"
        }, null, -1)),
        _ctx.showPCHeaderV2 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _ctx.showHeaderNav ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                        _createElementVNode("pg-icon", {
                            name: "left",
                            size: "24px",
                            onClick: _cache[0] || (_cache[0] = //@ts-ignore
                            function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = arguments[_key];
                                }
                                return _ctx.handleBack && _ctx.handleBack(...args);
                            })
                        })
                    ], 512), [
                        [
                            _vShow,
                            _ctx.showBackBtn
                        ]
                    ])
                ])
            ])) : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("a", {
                        href: "/",
                        class: "pe-main-header_logo"
                    }, [
                        _createElementVNode("img", {
                            src: _imports_0
                        })
                    ], -1)),
                    _createVNode(_component_EnvTag, {
                        class: "pe-main-header_env-hint"
                    })
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.title), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _ctx.isInternational ? (_openBlock(), _createBlock(_component_BizArea, {
                            key: 0
                        })) : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        ((_ctx_employeeInfo = _ctx.employeeInfo) === null || _ctx_employeeInfo === void 0 ? void 0 : (_ctx_employeeInfo_avatar = _ctx_employeeInfo.avatar) === null || _ctx_employeeInfo_avatar === void 0 ? void 0 : _ctx_employeeInfo_avatar.avatar_72) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("img", {
                                src: _ctx.employeeInfo.avatar.avatar_72
                            }, null, 8, _hoisted_14)
                        ])) : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, _toDisplayString((_ctx_userInfo = _ctx.userInfo) === null || _ctx_userInfo === void 0 ? void 0 : _ctx_userInfo.name), 1)
                    ])
                ])
            ])
        ])) : _ctx.showHeaderNav ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("div", _hoisted_19, [
                        _createElementVNode("pg-icon", {
                            name: "left",
                            size: "24px",
                            onClick: _cache[1] || (_cache[1] = //@ts-ignore
                            function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = arguments[_key];
                                }
                                return _ctx.handleBack && _ctx.handleBack(...args);
                            })
                        })
                    ], 512), [
                        [
                            _vShow,
                            _ctx.showBackBtn
                        ]
                    ]),
                    _createVNode(_component_EnvTag, {
                        class: "pe-main-header_env-hint"
                    })
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _ctx.titleOptions && _ctx.titleOptions.length ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass("pe-main-header_select ".concat(_ctx.showTitleOptions ? 'pe-main-header_select-opened' : ''))
                    }, [
                        _createElementVNode("div", {
                            class: "pe-main-header_title",
                            onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.toggleTitleOptions()),
                            onKeyup: _cache[3] || (_cache[3] = ($event)=>_ctx.toggleTitleOptions())
                        }, _toDisplayString((_ctx_titleSelected = _ctx.titleSelected) === null || _ctx_titleSelected === void 0 ? void 0 : _ctx_titleSelected.title), 33),
                        _withDirectives(_createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_van_popup, {
                                show: _ctx.showTitleOptions,
                                "onUpdate:show": _cache[5] || (_cache[5] = ($event)=>_ctx.showTitleOptions = $event),
                                class: "pe-main-header_select-options_content",
                                position: "top",
                                duration: "0.2",
                                "get-container": ".pe-main-header_select-options",
                                "close-on-popstate": "",
                                onOpen: _cache[6] || (_cache[6] = ($event)=>_ctx.toggleTitleOptionsWrapper(true)),
                                onClose: _cache[7] || (_cache[7] = ($event)=>_ctx.toggleTitleOptionsWrapper(false))
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_CellSelect, {
                                            type: "radio",
                                            modelValue: _ctx.titleSelected,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.titleSelected = $event),
                                            optionAsValue: "",
                                            options: _ctx.titleOptions,
                                            onChange: _ctx.handleTitleOptionChange
                                        }, null, 8, [
                                            "modelValue",
                                            "options",
                                            "onChange"
                                        ])
                                    ]),
                                _: 1
                            }, 8, [
                                "show"
                            ])
                        ], 512), [
                            [
                                _vShow,
                                _ctx.showTitleOptionsWrapper
                            ]
                        ])
                    ], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.title), 1))
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", {
                    class: "pe-main-header_side"
                }, null, -1))
            ])
        ])) : _createCommentVNode("", true)
    ], 8, _hoisted_1);
}
